<template>
    <div class="info">
        <div class="title">
            <span @click="handleClickMapType('total')">全部流入流出</span>
            <span @click="handleClickMapType('community')">小区流入流出</span>
            <!-- <span @click="handleClickMapType('company')">商铺流入流出</span> -->
        </div>
        <div id="map" class="map"></div>
    </div>    
</template>
<script>
import { MapLoader,syncLoadJs } from '../../../../config/Amap'
import mapMockData from './mapMockData';
export default {
    data(){
        return {
            Amap: null, //引入得地图实例
            map: null, //底图
            disCountry: null, //行政区图
            layer: null, //归来人员归属地连接线
            HexLayer: null, //热力图蜂窝图
            layerData: [], //归来数据
            HexLayerData: [] //热力图数据
        }
    },
    methods: {
        async initMap(){
            this.Amap = await MapLoader({ 
                plugins: [
                    'AMap.Autocomplete',
                    'AMap.Scale',
                    'AMap.OverView',
                    'AMap.ToolBar',
                    'AMap.MapType',
                    'AMap.PolyEditor',
                    'AMap.Geocoder',
                    'AMap.MouseTool',
                    'AMap.PolyEditor',
                    'AMap.CircleEditor',
                    'AMap.DistrictLayer',
                    'AMap.Map3D'
                ]
            });

            this.map = new this.Amap.Map('map',{
                zoom: 3.8, //缩放级别
                mapStyle: 'amap://styles/darkblue', //地图样式
                center: [107.492897, 32.63641], //中心点
                pitch: 15,  //视角角度
                rotation:15, //视角左右角度
                viewMode: "3D",
                features: ["bg", "road", "point"]
            })
            

            this.drawToatal();

        },
        // 获取返程信息
        async getBackInfo(starttime,endtime){
            let res = await this.$get(this.urlobj.getPosition,{
                communityId: this.$route.query.communityId || this.$store.state.streetorcommunityid,
                beginTime: starttime,
                endTime: endtime,
                type: 1
            })
            res.rows.forEach(item => {
                for(let i = 1; i <= item.value; i ++){
                    let obj =  {
                        coordinate: [
                            `${ JSON.parse(item.lnglat).x },${ JSON.parse(item.lnglat).y }`,
                            '114.492897,36.63641',
                        ],
                        city: item.cityName
                    }
                    this.layerData.push(obj)
                }
            })
            this.drawToatal();
        },
        // 获取小区进出信息
        async getInAndOutInfo(starttime,endtime){
            let res = await this.$get(this.urlobj.getPosition,{
                communityId: this.$route.query.communityId || this.$store.state.streetorcommunityid,
                beginTime: starttime,
                endTime: endtime,
                type: 2
            })
            this.HexLayerData = res.rows.map(item => {
                item.lnglat = `${ JSON.parse(item.lnglat).x },${ JSON.parse(item.lnglat).y }`
                return item
            })
            this.drawCommnuity();
        },
        // 处理点击按钮
        handleClickMapType(type){
            switch(type){
                case 'total': this.getBackInfo(); break;
                case 'community': this.getInAndOutInfo(); break;
                case 'company': console.log('公司'); break;
            }
        },
        // 画行政区位信息
        drawCountry(type){

            if(type == 'china'){ //画整个中国地图
                this.disCountry = new this.Amap.DistrictLayer.Country({
                    zIndex:10,
                    SOC:'CHN',
                    depth:2,
                    styles:{
                        'nation-stroke':'#215270',
                        'coastline-stroke':'#215270',
                        'province-stroke':'white',
                        'city-stroke': 'rgba(255,255,255,0)',//中国特有字段
                        'fill': function(props){//中国特有字段
                            return 'rgb(33,82,112)'
                        }
                    }
                })
            }else{ //画丛台地图
                this.disCountry = new this.Amap.DistrictLayer.Province({
                    zIndex:12,
                    adcode:['130403'],
                    depth:2,
                    styles:{
                        'fill':function(properties){
                            return 'rgba(33,82,112,0.4)';
                        },
                        'province-stroke':'cornflowerblue',
                        'city-stroke': 'white',//中国地级市边界
                        'county-stroke': 'rgba(255,255,255,0.5)'//中国区县边界  
                    }
                })
            }


            this.disCountry.setMap(this.map)
        },
        // 绘画归来人员所属地连线
        async drawToatal(){
            // 将所有线清空
            if(this.layer){
                this.layer.setMap(null); 
            }
             //清除国家行政区位线
            if(this.disCountry) {
                this.disCountry.setMap(null);
            }

            // 设置中心点及缩放级别
            this.map.setZoomAndCenter(3.8,[107.492897, 32.63641]);

            // 设置俯视角度
            this.map.setPitch(15);

            // 标注区分中国地图
            this.drawCountry('china');

            const positionText = new this.Amap.Marker({
                zIndex: 999,
                text: '丛台',
                position: new this.Amap.LngLat("114.492897", "36.63641"),
                icon: '//vdata.amap.com/icons/b18/1/2.png',
                offset: new AMap.Pixel(-10, -10),
            })




            this.map.add([positionText]);

            // 画出各个来源地信息
            this.layerData.forEach(item => {
                const fromPosition = new this.Amap.Marker({
                    position: new this.Amap.LngLat(item.coordinate[0].split(',')[0],item.coordinate[0].split(',')[1]),
                    content: `
                        <div style="position:relative;">
                            <span style="position: absolute;top: 0;left: 0;width: 15px;height: 15px;border-radius: 50%;background: #00f3ff"></span>
                            <span style="position: absolute;top: -4px;left: -4px;width: 23px;height: 23px;border-radius: 50%;border: 2px solid #00f3ff;"></span>
                            <span style="position: absolute;top: 0;left: 20px;fontSize: 20px; color: #00f3ff">${ item.city }</span>
                        </div>
                    `
                })
                
                this.map.add(fromPosition);
            })
            
            // 画连接线
            this.layer = new Loca.LinkLayer({
                map: this.map
            });

            // let lineData = mapMockData;

            this.layer.setData(this.layerData, {
                lnglat: 'coordinate'
            });

            this.layer.setOptions({
                blendMode: 'lighter',
                style: {
                    // 曲率 [-1, 1] 区间
                    curveness: 1,
                    opacity: 1,
                    width: 5,
                    color: '#02e9f1'
                }
            });

            // 渲染
            this.layer.render();
        },
        // 画社区热力图
        drawCommnuity(){

            // 将所有线清空并将丛台名称和原点去除
            this.layer.setMap(null);  //清除连接线
            this.disCountry.setMap(null); //清除国家行政区位线
            this.map.clearMap(); //清除地图标注信息

            // let heatdata = [
            //     {
            //         lnglat: '114.592897,36.63641',
            //         value: 18
            //     },
            //     {
            //         lnglat: '114.592897,36.63641',
            //         value: 18
            //     },
            //     {
            //         lnglat: '114.592817,36.63641',
            //         value: 18
            //     },
            // ]

            console.log(this.HexLayerData);

            // 设置中心点及缩放级别
            this.map.setZoomAndCenter(16,[this.HexLayerData[this.HexLayerData.length - 1].lnglat.split(',')[0],this.HexLayerData[this.HexLayerData.length - 1].lnglat.split(',')[1]]);
            // 设置地图倾斜角度
            this.map.setPitch(53);
            // 画行政区域
            this.drawCountry('area');

            // 画热力图
            this.HexLayer = new Loca.HexagonLayer({
                map: this.map
            });

            this.HexLayer.setData(this.HexLayerData, {
                lnglat: 'lnglat',
                value: 'value',
                type: 'json'
            });

            this.HexLayer.setOptions({
                unit: 'meter',
                heightUnit: 'meter',
                style: {
                    color: [
                        '#0553A1',
                        '#0B79B0',
                        '#10B3B0',
                        '#7CCF98',
                        '#DCE872'
                    ],
                    height: [0, 500],
                    radius: 15,
                    gap: 2,
                    opacity: 1,
                }
            });

            
            // 渲染
            this.HexLayer.render();

        }
    },
    mounted(){
        this.initMap();
        this.getBackInfo();
    }
}
</script>
<style lang="less" scoped>
.info {
    box-sizing: border-box;
    padding: 0 0 30px;
    .title {
        height: 50px;
        display: flex;
        align-items: center;
        color: #fff;
        span {
            background: rgba(0,0,1,.9);
            box-shadow: inset 0 0 40px rgba(34,140,251,.77);
            padding: 10px 20px;
            margin-right: 10px;
            cursor: pointer;
        }
    }
    .map{
        width: 100%;
        height: calc(100% - 50px);
    }
}
</style>